/* eslint-disable @typescript-eslint/naming-convention */
import {useTranslation} from 'react-i18next';
import {Center} from '~/components/Center';
import {Title} from '~/components/Title';
import {TitleSection} from '~/components/TitleSection';
import {useState} from 'react';
import {ContactoPageType} from '~/services/GetPageContactService';
import {ContactFormValues, Form} from './Form';
import {Info} from './Info';
import {useLocation, useNavigate} from '@remix-run/react';
import {ImageHeader} from '~/features/shared';

export function ContactPage({page}: {page: ContactoPageType}) {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  const [data, setData] = useState<any>(null);

  const {t} = useTranslation();

  const onSubmit = async (values: ContactFormValues) => {
    setIsLoading(true);
    setData(null);
    setError(null);

    try {
      const res = await fetch('/api/enviar-contacto', {
        method: 'POST',
        body: JSON.stringify(values),
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (res.status !== 200) {
        setError(new Error('Ha ocurrido un error al enviar el formulario.'));
      } else {
        navigate('/gracias', {
          state: {
            from: location.pathname,
          },
        });
        const data = await res.json();
        setData(data);
      }
    } catch (e) {
      setError(e as Error);
    }

    setIsLoading(false);
  };

  return (
    <Center className="w-full lg:px-20 lg:pt-10">
      <ImageHeader
        image={page.headerImage}
        breadcrumb={[
          {
            title: t('inicio'),
            to: '/',
          },
          {
            title: t('contacto'),
          },
        ]}
        title={t('contacto')}
      />

      <div className="px-5 mb-24 sm:px-10">
        <section>
          <TitleSection i18nKey="contacto" className="mb-4 text-center" />

          <Title
            i18nKey="pages:contacto:title"
            className="mb-16 text-3xl text-center"
          />

          <div className="flex flex-col gap-16 lg:flex-row">
            <Form
              data={data}
              error={error}
              isLoading={isLoading}
              onSubmit={onSubmit}
              className="flex-1"
            />

            <Info page={page} className="flex-1" />
          </div>
        </section>

        {/* <HorizontalDivider className="my-16" />

        <section className="grid grid-cols-1 gap-8 md:grid-cols-2">
          {locations.map((l, i) => {
            return (
              <div key={i}>
                <iframe
                  title="HPMLED"
                  height={400}
                  className="mb-4 w-full rounded-xl"
                  loading="lazy"
                  allowFullScreen
                  referrerPolicy="no-referrer-when-downgrade"
                  src={l.src}
                />

                <h1 className="mb-2 text-xl font-bold uppercase text-blue-dark">
                  {l.title}
                </h1>

                <p className="text-sm font-medium text-gray-500">
                  {l.location}
                </p>
              </div>
            );
          })}
        </section> */}
      </div>
    </Center>
  );
}
